import SingleCategorySelector, {
  SingleCategorySelectorProps,
} from "@components/plasmic/custom-options/category-selector/single-category-selector";

const BrandSelector = (props: SingleCategorySelectorProps) => {
  return <SingleCategorySelector {...props} selectorSlugs={props.contextData?.brandSlugs ?? []} />;
};

export default BrandSelector;
